import React from "react";
import useLinks from "../hooks/useStoryblokLinks";
/// Link
// external_link:string -> any url that is not internal
// storyblok_link_field: Storyblok Link Object from the field data
// storyblok_richtext_link: Storyblok Link Object from the richtext object (different than field)
// override_link_target:string The forced value for the link target.
// extend_path:string Adds additional path to a story (Used for tag results)
function Link({
  external_link,
  storyblok_link_field,
  storyblok_richtext_link,
  story_uuid,
  extend_path,
  override_link_target,
  override_story_language,
  withClass = "",
  activeClass = "",
  onClick,
  children,
  aria_label
}) {
  const map = useLinks()
  let linkUrl = "";
  let linkTarget = "_self";
  let isActive = false;

  if (external_link) {
    linkUrl = external_link;
  }
  // Link Field Links
  if (storyblok_link_field) {
    linkUrl = storyblokLinkFieldToHref(storyblok_link_field, map);
    if (storyblok_link_field.target) {
      linkTarget = storyblok_link_field.target;
    }
    if (storyblok_link_field.anchor) {
      linkUrl += "#" + storyblok_link_field.anchor;
    }
    if(activeClass && window && typeof window !== "undefined" && linkUrl === window.location.pathname) {
      isActive = true;
    }
  }
  // Richtext Links
  if (storyblok_richtext_link) {
    linkUrl = richtextLinkToHref(storyblok_richtext_link, map);
    linkTarget = storyblok_richtext_link.target;
    if (storyblok_richtext_link.anchor) {
      linkUrl += "#" + storyblok_richtext_link.anchor;
    }
  }
  // Storyblok uuid
  if (story_uuid) {
    if(map && map[story_uuid]){
        linkUrl = map[story_uuid].real_path;
    }
    if(linkUrl && extend_path) {
      if(!linkUrl.endsWith("/")) {
        linkUrl += "/";
      }
      linkUrl += extend_path;
    }
  }
  // New Window Override
  if (override_link_target) {
    linkTarget = override_link_target;
  }
//   // Language Override
//   if(override_story_language) {
//     linkUrl = overrideLanguage(linkUrl, override_story_language)
//   }

  let classList = []
  if(withClass) { classList.push(withClass) }
  if(isActive) { classList.push(activeClass) }
  return (
    <a
      href={linkUrl}
      target={linkTarget}
      onClick={onClick}
      className={classList.join(" ")}
      aria-label={aria_label || null}
    >
      {children}
    </a>
  );
}

function storyblokLinkFieldToHref(storyblok_link, map) {
  switch(storyblok_link.linktype) {
    case "asset":
      return storyblok_link.url;
    case "email":
      return `mailto:${storyblok_link.email}`;
    case "url":
      return storyblok_link.url;
    case "story":
        if(map && map[storyblok_link.id]){
            return map[storyblok_link.id].real_path;
        }
    default:
      return storyblok_link.cached_url || "";
  }
}
function richtextLinkToHref(storyblok_link, map) {
  switch(storyblok_link.linktype) {
    case "asset":
      return storyblok_link.href;
    case "email":
      return `mailto:${storyblok_link.href}`;
    case "story":
        if(map && map[storyblok_link.uuid]){
            return map[storyblok_link.uuid].real_path;
        }
    case "url":
      return storyblok_link.href;
    default:
      return storyblok_link.href || "";
  }
}
// function overrideLanguage(url, language) {
//   if(!url || !language) {return url}
//   if(language !== "en" && url.startsWith("/news")) {
//     return `/${language}${url}`
//   }
//   return url
// }

export default Link;
